<template>
    <div class="agreement" :class="{'agreementDark': isDark}">
        <h3>{{jh_newname}}数据服务之连续包月服务协议</h3>

        <h4>1、服务条款的确认和接纳</h4>

        为了满足您长期购买{{jh_newname}}数据服务的需求，{{jh_newname}}推出“连续包月服务”，相关服务细则请关注本协议约定。

        您若确认采购无误，请点击 "连续包月 "选项采购该产品，本协议即构成您使用{{jh_newname}}所提供的连续包月服务（以下简称“本项服务“）之先决条件。除非您接受本协议条款，否则您无权使用本项服务；您选择使用本项服务行为将视为同意接受本协议的约束。当您使用本项服务时，您的使用行为将被视为同意本项服务的相关条款以及{{jh_newname}}在本项服务中所发出的各类公告。

        <h4>2.所有权与使用权</h4>

        本项服务涉及到的一切网络服务之所有权以及相关之知识产权均归“{{jh_newname}}“依法所有，受中华人民共和国法律及国际公约的依法保护，您不因使用本项服务而自动获得前述的任一或全部权利。并且，{{jh_newname}}可以依据《用户服务协议》对本协议中的任一或全部条款进行修改，或对本项服务进行调整，对上述修改或调整，{{jh_newname}}会予以公告，并自公告之日起7日后生效。

        <h4>3.连续包服务类型及服务内容范围</h4>

        {{jh_newname}}之连续包月服务现有连续包月、连续包季、连续包年等类型，并将根据用户需求不断丰富连续包月服务类型。您通过使用本项服务，还可以获得定期查看{{jh_newname}}付费数据模型的服务。除非{{jh_newname}}另外通知，否则本项服务的有效期按自然天数计算。

        <h4>4.自动续费服务说明</h4>

        <h5>4.1</h5>
        自动续费服务是出于您对于自动续费的需求、在您已开通连续包月服务的前提下，为避免您因疏忽或其他原因导致未能及时续费造成损失而推出的服务，您同意授权{{jh_newname}}在当前数据包月服务有效期即将过期时，从您在{{jh_newname}}的自有充值账户、或与{{jh_newname}}账号绑定的第三方支付账户、银行卡或通信账户（以下统称"账户"）之余额中代扣下一个计费周期的服务费用。自动续费服务实现的前提是您已将您的{{jh_newname}}账号与上述账户绑定，并且账户留有足够余额以使自动续费成功。
        <h5>4.2</h5>
        因上述账户中可扣款余额不足导致的续费失败，由您自行承担责任。
        <h5>4.3</h5>
        如在自动续费过程中出现差错，{{jh_newname}}将和您密切配合查明原因，各自承担因己方过错造成的损失；若因双方各自存在不均等过错造成的损失，由双方按过错的程度承担相应责任；双方共负责任的，由双方均摊责任。
        <h5>4.4</h5>
        {{jh_newname}}向您提供的自动续费服务仅限于在{{jh_newname}}平台使用，{{jh_newname}}平台以外的付款或任何以恶意破解等非法手段将{{jh_newname}}所提供的自动续费服务与{{jh_newname}}平台分离的行为，均不属于本协议中约定的服务。由此引起的一切法律后果由行为人负责，{{jh_newname}}将依法追究行为人的法律责任。

        <h4>5.连续包服务的开通</h4>

        <h5>5.1</h5>
        如您自IOS端开通本项服务，则视为您授权{{jh_newname}}在您的当前计费周期即将到期时，从您的iTunes账户余额中代扣下一个计费周期服务费，计费周期包括但不限于月度、季度、年度等。
        <h5>5.2</h5>
        若您通过"IOS端"或Android客户端开通连续包月套餐，则视为您授权{{jh_newname}}在您的当前计费周期即将到期时，从您的{{jh_newname}}账户嗨币余额中代扣下一个计费周期的服务费，计费周期包括但不限于月度、季度、年度等。
        <h5>5.3</h5>
        对于所选择的支付渠道，您有义务保持定期关注并确保其于该支付方式的账号项下有充足的余额用于满足本项服务的应用。如因账户余额不足以支付下一计费周期的服务费，则{{jh_newname}}有权暂停您通过本项服务所接入的{{jh_newname}}数据服务。

        <h4>6.连续包服务有效期</h4>

        除非{{jh_newname}}另行规定，否则您获得的连续包月服务均为长期有效。
        <br/>{{jh_newname}}将于您当前的服务期届满前向您以短信、或站内信、或微信公众号等方式发送“连续包月服务续费提示“，如果您未对该信息进行回复，或所回复之信息未尽符合{{jh_newname}}平台的要求，则{{jh_newname}}有权视同您委托{{jh_newname}}通过您默认的支付方式续取相应的服务费用。
        <br/>本项服务由您自主选择是否取消，若您选择不取消，则视为您同意{{jh_newname}}按照本协议进行不定期的扣款尝试，一旦扣款成功，{{jh_newname}}将为您开通下一个计费周期的连续包月服务。若在自动续费时/之前，{{jh_newname}}包月服务价格发生调整，应以现时有效的价格为准。
        <br/>{{jh_newname}}特别提醒您：当您选择使用连续包月服务后，通过自动续费服务所支付的费用，{{jh_newname}}将视同您选择认购了{{jh_newname}}的相应付费服务。因此，{{jh_newname}}将不以任何方式对您所支付的费用予以退还。

        <h4>7.连续包服务的退订</h4>

        <h5>7.1</h5>
        您可自主选择退订本项服务。
        <h5>7.2</h5>
        解约流程，即关闭连续包月服务的步骤：
        <br/>您使用苹果ID开通的连续包月服务产品，在"设置"→"iTunesStore与App Store"→"Apple ID"→"查看Apple ID"→ 在账户设置页面点击"订阅"→ 取消{{hiscores ? '嗨比分' : '即嗨'}}数据订阅即可。
        <br/>使用Android客户端的用户可以直接在“{{jh_newname}}”app里“我的”→“付费记录”→“数据包月”页面中点击“放弃自动续费优惠”按钮取消。温馨提示：连续包月套餐取消成功后，不影响您当期已生效的会员权益，会员权益到期后将不再续费。
        <br/>您在选择终止本项服务前已经委托{{jh_newname}}连续包月自动续费的指令仍然有效。
        <div class="lasttip">以上说明最终解释权归{{jh_newname}}所有</div>
    </div>
</template>

<script>
import { appChangeName, isHiscores, setTitle } from "@/utils/base.js"
export default {
    name: "monthlyAgreement",
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    mounted () {
        setTitle('连续包月服务协议')
        document.getElementsByTagName('title')[0].innerHTML = '连续包月服务协议';
    },
    data () {
        return {
            jh_newname: appChangeName() ? '即嗨体育' : isHiscores() ? '嗨比分' : '即嗨比分',
            hiscores: isHiscores()
        };
    }
}
</script>

<style lang="less" scoped>
.agreement{
    padding:0 10px;
    line-height: 20px;
    h3,h4,h5{
        color:#171717;
        font-weight: bold;
        margin: 5px;
    }
    b{
        color:#171717;
        font-weight: bold;
    }
    h3{
        font-size: 20px;
    }
    h4{
        font-size: 17px;
    }
    h5{
        font-size: 15px;
    }
    .um{
        font-weight: 700;
        color: #000;
    }
    em{
        font-weight: bold;
        color:#171717;
    }
    i{
        &.special{
            display: none;
        }
    }
    .lasttip{
        color:#bca272;
        text-align: center;
    }
}
.agreementDark{
    overflow: hidden;
    background-color: #191919;
    color: #d2d2d2;
    h2,h3,h5,b,.um,em{
        color: #d3d3d3;
    }

}
</style>
